import * as types from 'store/types'
import { ReactComponent as ResponseIcon } from 'assets/images/icons/response.svg'
import { ReactComponent as PagesIcon } from 'assets/images/icons/pages.svg'
import { getLocalStorageValue, setLocalStorageValue } from 'utils/storageUtils'
import { emptyCache } from 'utils/helpers'

const initialState = {
  changelog: [],
  mainmenuTabs: [
    { title: 'Pages', key: 'pages', icon: <PagesIcon />, isActive: true },
    { title: 'Responses', key: 'responses', icon: <ResponseIcon />, isActive: false }
  ],
  isMainMenuOpen: window.innerWidth < 1400 ? false : true,
  showInviteMembersModal: false,
  free_items_limit: 0,
  total_items_count: 0,
  isResponseDropdownVisible: false,
  isPageDropdownVisible: false,
  responseDropdownPosition: {left: 0, top: 0},
  pageDropdownPosition: {left: 0, top: 0},
  currentResponseDropdown: {},
  currentPageDropdown: {},
  isCopyingLoading: false,
  dropdownDirection: 'down'
}

const setAppVersion = async (data) => {
  const _app_version = await getLocalStorageValue('app_version')
  if (_app_version !== data.app_version) {
    setLocalStorageValue('app_version', data.app_version)
    emptyCache()
  }
}

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ACTIVE_TAB: {
      const mainmenuTabs = state.mainmenuTabs
      for (const i in mainmenuTabs) {
        mainmenuTabs[i].isActive = false
        if (mainmenuTabs[i].key === action.key) {
          mainmenuTabs[i].isActive = true
        }
      }
      return {
        ...state,
        mainmenuTabs
      }
    }
    case types.TOGGLE_MAINMENU: {
      return {
        ...state,
        isMainMenuOpen: action.status
      }
    }
    case types.TOGGLE_INVITE_TEAMMATES: {
      return {
        ...state,
        showInviteMembersModal: action.status
      }
    }
    case types.SET_CHANGELOGS: {
      setAppVersion(action.data)
      return {
        ...state,
        app_version: action.data.app_version,
        changelog: action.data.changelog,
        free_items_limit: action.data.free_items_limit
      }
    }
    case types.SET_TOTALITEMS: {
      return {
        ...state,
        total_items_count: action.data.total_items_count
      }
    }

    case types.SET_IS_RESPONSE_DROPDOWN_VISIBLE: {
      return {...state, isResponseDropdownVisible: action.payload}
    }
    case types.SET_RESPONSE_DROPDOWN_POSITION: {
      return {...state, responseDropdownPosition: action.payload}
    }
    case types.SET_CURRENT_RESPONSE_DROPDOWN: {
      return {...state, currentResponseDropdown: action.payload}
    }

     case types.SET_IS_PAGE_DROPDOWN_VISIBLE: {
      return {...state, isPageDropdownVisible: action.payload}
    }
    case types.SET_PAGE_DROPDOWN_POSITION: {
      return {...state, pageDropdownPosition: action.payload}
    }
    case types.SET_CURRENT_PAGE_DROPDOWN: {
      return {...state, currentPageDropdown: action.payload}
    }

    case types.SET_IS_COPYING_LOADING: {
      return {...state, isCopyingLoading: action.payload}
    }

    case types.SET_DROPDOWN_DIRECTION: {
      return {...state, dropdownDirection: action.payload}
    }
    default:
      return state
  }
}
export default appReducer
